'use strict';

import selectBox from '../modules/SelectBox';

/**
 *  this routine is used for dealer selection during registration and checkout
 **/
export default function() {
  var element = $(document);
  var retailerSelector = element.find('[data-retailer-selector]');
  var deliveryMethodSelector = element.find('[data-delivery-method-selector]');
  var deliveryMethodTargets = element.find('[data-options-target1]'); // used for
  // rendering
  // delivery methods
  // in checkout

  // Is a retailer already selected?
  var selectedDealerName = $('#selectedDealerName').html();

  if (retailerSelector && retailerSelector.is(':visible') && !selectedDealerName) {
    // Hide delivery methods until a retailer has been selected
    deliveryMethodSelector.addClass('hide');
  }

  setupOptionBoxEventHandlers();

  deliveryMethodTargets.on('click', function(event) {
    updateDeliveryMethodTarget($(event.currentTarget));
    event.stopPropagation();
  });

  function updateDeliveryMethodTarget(selected) {
    deliveryMethodTargets.removeClass('selected');
    selected.addClass('selected');
  }

  $('input[name=zipCode]').keypress(function(e) {
    if ((e.which && e.which == 13) || (e.keyCode && e.keyCode == 13)) {
      showDealers('');
      return false;
    } else {
      return true;
    }
  });

  $('#getDealers').click(function(e) {
    e.preventDefault();

    showDealers($(this).serialize());
  });

  function showDealers(requestData) {
    if ($.trim($('input[name=zipCode]').val())) {
      $('#zip-code-is-empty-text').css({
        display: 'none',
      });

      $('#selectedRetailer').css({
        display: 'none',
      });
      var requestUrl = getDealerUrl() + '?q=' + $('input[name=zipCode]').val();
      getDealersAjax(requestUrl, requestData);
    } else {
      if ($('#zip-code-is-empty-text').css('display') == 'none') {
        if (
          !$('input[name=zipCode]')
            .closest('div')
            .hasClass('form__item--error')
        ) {
          $('#zip-code-is-empty-text').css({
            display: 'block',
          });
        }
      }
      return;
    }
  }

  function defaultCheckboxValue(formField) {
    var optin = $('#' + formField + 'Val').val();
    if (optin == 'true') {
      $('#' + formField).attr('checked', 'checked');
    }
  }

  function getDealerUrl() {
    if (document.location.href.indexOf('delivery-method') != -1) {
      var selectedDealerName = $('#selectedDealerName').html();
      if (selectedDealerName) {
        return 'getSelectedDealers';
      } else {
        return 'getDealers';
      }
    } else if (document.location.href.indexOf('register') != -1) {
      return 'register/getDealers';
    } else {
      return 'login/getDealers';
    }
  }

  function hideShowDeliveryOption(option, selectedDealerSupportsOption) {
    if (selectedDealerSupportsOption.length > 0) {
      // show delivery option
      $('.form__retailer-option.' + option).css({
        display: 'flex',
      });
    } else {
      //uncheck and hide delivery option
      $('.form__retailer-option.' + option)
        .find('input[type="radio"]:checked')
        .prop('checked', false);

      $('.form__retailer-option.' + option).css({
        display: 'none',
      });
    }
  }

  function verifySelectedRetailerCanDeliver() {
    if ($('input[name=selectedDealer]:checked', '#selectDeliveryMethodForm').attr('id') !== undefined) {
      var selectedDealer = $('input[name=selectedDealer]:checked', '#selectDeliveryMethodForm').attr('id');

      $('#preferredDealerCode').val(selectedDealer);

      if (selectedDealer.length > 0) {
        // dealer selected on current dealer list page
        var selectedDealerSupportsDealerDelivery = $.trim($('#' + selectedDealer + '_dealerDelivers').html());
        var selectedDealerSupportsClickCollect = $('#' + selectedDealer + '_clickCollect');

        hideShowDeliveryOption('dealerDelivers', selectedDealerSupportsDealerDelivery);
        hideShowDeliveryOption('clickCollect', selectedDealerSupportsClickCollect);
      }
    }
  }

  function createLoginPagination(data) {
    var paginationHTML = '';

    if (data.currentPage > 0) {
      var prevPage = data.currentPage - 1;
      paginationHTML = paginationHTML + "<div class='pagination__cell'>";
      paginationHTML =
        paginationHTML +
        "<a id='getPage' href='#' data-page='" +
        prevPage +
        "' class='js-dealer-page pagination__button arrow-left-icon'>previous</a>";
      paginationHTML = paginationHTML + '</div>';
    }
    paginationHTML = paginationHTML + "<div class='pagination__cell'>";
    paginationHTML =
      paginationHTML +
      "<p class='pagination__text text-small'>" +
      (data.currentPage + 1) +
      "<span class='text-small-emphasized'>&nbsp;of&nbsp;</span>";
    paginationHTML = paginationHTML + data.numberOfPages + '</p></div>';

    if (data.currentPage + 1 < data.numberOfPages) {
      var nextPage = data.currentPage + 1;
      paginationHTML = paginationHTML + "<div class='pagination__cell'>";
      paginationHTML =
        paginationHTML +
        "<a id='getPage' href='#' data-page='" +
        nextPage +
        "' class='js-dealer-page pagination__button arrow-right-icon'>next</a>";
      paginationHTML = paginationHTML + '</div>';
    }

    return paginationHTML;
  }

  function createCheckoutPagination(data) {
    var paginationHTML = '';

    if (data.currentPage > 0) {
      var prevPage = data.currentPage - 1;
      paginationHTML = paginationHTML + "<div class='pagination__cell'>";
      paginationHTML =
        paginationHTML +
        "<a id='getPage' href='#' data-page='" +
        prevPage +
        "' class='js-dealer-page pagination__button arrow-left-icon--weak'>previous</a>";
      paginationHTML = paginationHTML + '</div>';
    }
    paginationHTML = paginationHTML + "<div class='pagination__cell'>";
    paginationHTML =
      paginationHTML +
      "<p class='pagination__text text-small'>" +
      (data.currentPage + 1) +
      "<span class='text-small-emphasized'>&nbsp;of&nbsp;</span>";
    paginationHTML = paginationHTML + data.numberOfPages + '</p></div>';

    if (data.currentPage + 1 < data.numberOfPages) {
      var nextPage = data.currentPage + 1;
      paginationHTML = paginationHTML + "<div class='pagination__cell'>";
      paginationHTML =
        paginationHTML +
        "<a id='getPage' href='#' data-page='" +
        nextPage +
        "' class='js-dealer-page pagination__button arrow-right-icon--weak'>next</a>";
      paginationHTML = paginationHTML + '</div>';
    }

    return paginationHTML;
  }

  function setupOptionBoxEventHandlers() {
    var element = $(document);
    var retailerTargets = element.find('[data-options-target]');

    retailerTargets.on('click', function(event) {
      retailerTargets.removeClass('selected');
      $(event.currentTarget).addClass('selected');
      // Show delivery methods after a retailer has been selected
      deliveryMethodSelector.removeClass('hide');
      event.stopPropagation();
    });
  }

  $(document).delegate($('input[name=selectedDealer]:radio'), 'change', function() {
    // save selected dealer
    var preferredDealer;
    var selectedDealerSupportsDealerDelivery, selectedDealerSupportsClickCollect;
    if ($('.page-login').length) {
      preferredDealer = $('input[name=selectedDealer]:checked', '#trekRegisterForm').attr('id');
      $('#preferredDealerCode').val(preferredDealer);

      var preferredDealerAddr = $.trim($('#' + preferredDealer + '_addr').html());
      $('#preferredDealerCodeAddress').val(preferredDealerAddr);
    } else {
      preferredDealer = $('input[name=selectedDealer]:checked', '#selectDeliveryMethodForm').attr('id');
      $('#preferredDealerCode').val(preferredDealer);
    }
    selectedDealerSupportsDealerDelivery = $.trim($('#' + preferredDealer + '_dealerDelivers').html());
    selectedDealerSupportsClickCollect = $('#' + preferredDealer + '_clickCollect');
    hideShowDeliveryOption('dealerDelivers', selectedDealerSupportsDealerDelivery);
    hideShowDeliveryOption('clickCollect', selectedDealerSupportsClickCollect);
  });

  $(document).delegate('.js-dealer-page', 'click', function(e) {
    e.preventDefault();

    var pageNum = $(this).data('page');
    var ajaxURL = getDealerUrl();
    var requestUrl = '';

    if (ajaxURL.indexOf('getSelectedDealers') != -1) {
      // get selected dealer for checkout
      var selectedDealerName = $('#selectedDealerName').html();

      requestUrl =
        ajaxURL + '?q=' + $('input[name=zipCode]').val() + '&page=' + pageNum + '&selectedDealer=' + selectedDealerName;
    } else {
      requestUrl = ajaxURL + '?q=' + $('input[name=zipCode]').val() + '&page=' + pageNum;
    }
    var requestData = $(this).serialize();
    getDealersAjax(requestUrl, requestData);
  });

  function getDealersAjax(requestUrl, requestData) {
    $.ajax({
      type: 'GET',
      url: requestUrl,
      data: requestData,
      success: function(data) {
        var paginationHTML = '';

        if ($('.page-login').length) {
          // Login/Register
          paginationHTML = createLoginPagination(data);
        } else {
          // Checkout
          paginationHTML = createCheckoutPagination(data);
        }

        if (data.dealerListHtml !== '') {
          $('ul.form__retailer-options.retailerResults')
            .empty()
            .append(data.dealerListHtml);
          $('#retailerResults').css({
            display: 'block',
          });

          $('#pagination')
            .empty()
            .append(paginationHTML);
        } else {
          $('ul.form__retailer-options.retailerResults')
            .empty()
            .append('<li>' + ACC.noRetailersFoundForZip + '</li>');
          $('#retailerResults').css({
            display: 'block',
          });

          $('#pagination').empty();
        }

        // Reinitialize the option box click functionality
        // after AJAX call
        setupOptionBoxEventHandlers();

        // pre-select selected dealer if possible

        if ($('#retailerResults').css('display') == 'block') {
          // get selected retailer
          var preferredDealer = $('#preferredDealerCode').val();

          if ($('#' + preferredDealer).length) {
            // last selected dealer exist on page so make
            // that the selected dealer
            $('#' + preferredDealer).prop('checked', true);
            //highlight selection
            $('#' + preferredDealer)
              .closest('[data-options-target]')
              .addClass('selected');

            verifySelectedRetailerCanDeliver();
          }
        }

        $('html, body').animate(
          {
            scrollTop: $($('#retailerResults')).offset().top,
          },
          1000
        );
      },
      error: function() {
        // alert("Failed to find retailers. Error details [" +
        // xht + ", " + textStatus + ", " + ex + "]");
      },
    });
  }

  function toggleRegisterButton(val) {
    if (val) {
      $('#register-button')
        .removeAttr('disabled')
        .removeClass('disabled');
    } else {
      $('#register-button')
        .attr('disabled', 'disabled')
        .addClass('disabled');
    }
  }

  $('#register-button').click(function(event) {
    event.preventDefault();
    $('#trekRegisterForm').submit();
  });

  if ($('#privacy-consent').length) {
    let privacyConsentCheckbox = $('#privacy-consent');
    toggleRegisterButton(privacyConsentCheckbox.is(':checked'));
    privacyConsentCheckbox.change(function() {
      toggleRegisterButton(privacyConsentCheckbox.is(':checked'));
    });
  }

  $('#chooseDeliveryMethod_continue_button').click(function(event) {
    event.preventDefault();
    var preferredDealer, delivery_method;
    if ($('#retailerResults').css('display') == 'block') {
      // get selected retailer
      preferredDealer = $('input[name=selectedDealer]:checked', '#selectDeliveryMethodForm').attr('id');

      if (preferredDealer !== undefined) {
        // dealer selected on current dealer list page
        $('#preferredDealerCode').val(preferredDealer);
      }
    } else if ($('#preferredDealerCode').length > 0) {
      // retailer has already been selected
    } else {
      $('#preferredDealerCode').val('');
    }

    // get selected delivery_method
    delivery_method = $('input[name=delivery_method]:checked', '#selectDeliveryMethodForm').attr('id');

    if (delivery_method !== undefined) {
      // delivery_method selected
      $('#selectedDeliveryMethod').val(delivery_method);
    }

    if (
      $('#preferredDealerCode')
        .val()
        .trim() === '' ||
      $('#selectedDeliveryMethod')
        .val()
        .trim() === ''
    ) {
      if (
        $('#selectedDeliveryMethod')
          .val()
          .trim() === ''
      ) {
        $('#formError').removeClass('hide');
        $('#deliveryMethodError').removeClass('hide');
        $('.form__retailer-options.deliveryMethodList').addClass('errorDiv');
        $('html, body').animate({scrollTop: 400}, 'slow');
      } else if (
        (retailerSelector.is(':visible') ||
          $('#selectedDeliveryMethod')
            .val()
            .trim()
            .indexOf('CLICK-AND-COLLECT-NO-BIKE') >= 0) &&
        $('#preferredDealerCode')
          .val()
          .trim() === ''
      ) {
        $('#deliveryMethodError').addClass('hide');
        $('.form__retailer-options.deliveryMethodList').removeClass('errorDiv');

        $('#formError').removeClass('hide');
        $('#preferredDealerError').removeClass('hide');
        $('.form__retailer-options.retailerResults').addClass('errorDiv');
        $('html, body').animate({scrollTop: 400}, 'slow');
      } else {
        $('#deliveryMethodError').addClass('hide');
        $('.form__retailer-options.deliveryMethodList').removeClass('errorDiv');
        $('#preferredDealerError').addClass('hide');
        $('.form__retailer-options.retailerResults').removeClass('errorDiv');
        $('#formError').addClass('hide');

        $('#selectDeliveryMethodForm').submit();
      }
    } else {
      $('#deliveryMethodError').addClass('hide');
      $('.form__retailer-options.deliveryMethodList').removeClass('errorDiv');
      $('#preferredDealerError').addClass('hide');
      $('.form__retailer-options.retailerResults').removeClass('errorDiv');
      $('#formError').addClass('hide');
      $('#selectDeliveryMethodForm').submit();
    }
  });

  selectBox('titleCode', 'name');
  defaultCheckboxValue('optin');
  defaultCheckboxValue('j_remember');
  verifySelectedRetailerCanDeliver();
}
